import { useQuery } from '@tanstack/react-query';
import { baselineMeasurementService } from '../../../Domain/BaselineMeasurements/Services';
import type { Comparison, SearchComparisonsResponse } from '../../../types/BaselineMeasurements';
import type { AxiosResponse } from 'axios';

interface SearchComparisonCompletedQueryVariables {
  connectionId: Comparison['connectionId'];
}

const QUERY_KEY = 'searchComparisonsCompleted';

export const useCountComparisonCompletedQuery = (variables: SearchComparisonCompletedQueryVariables) => {
  const { connectionId } = variables;
  return useQuery<SearchComparisonsResponse>({
    queryKey: [QUERY_KEY, connectionId],
    queryFn: async () => {
      const response = await baselineMeasurementService.countComparisonCompletedByConnectionId(connectionId);
      return (response as AxiosResponse).data;
    },
    enabled: !!connectionId,
  });
};
